import React, { useEffect, useState } from 'react';
import { Menu, MenuItem, Typography } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';

const OfficeGridActions = ({ drawerToggle, ...props }) => {
  const { row } = props;
  const [anchorElement, setAnchorElement] = useState(null);

  const menuId = 'action-menu-id';

  const handleActionsMenuOpen = (event) => {
    event.stopPropagation();
    event.preventDefault();
    setAnchorElement(event.currentTarget);
  };

  const handleMenuClose = (type) => () => {
    const rowData = { id: props.row.id, status: props.row.status };
    setAnchorElement(null);
    switch (type) {
      case 'deactivateOffice': {
        props.updateOfficeStatus(rowData);
        break;
      }
      case 'editOffice': {
        drawerToggle({ edit: props.row, open: true });
        break;
      }
      default:
        break;
    }
  };

  const menuItem = [
    {
      title: 'Edit',
      itemType: 'editOffice',
    },
    {
      title: 'Change Status',
      itemType: 'deactivateOffice',
    },
  ];

  return (
    <React.Fragment>
      <Typography aria-controls={menuId} aria-haspopup="true" onClick={handleActionsMenuOpen}>
        <MoreVertIcon style={{ fill: '#5780ab' }} />
      </Typography>
      <Menu
        anchorEl={anchorElement}
        id={menuId}
        keepMounted
        open={Boolean(anchorElement)}
        onClose={handleMenuClose()}
      >
        {menuItem.map((mItem, index) => (
          <MenuItem key={mItem.itemType + index} onClick={handleMenuClose(mItem.itemType)}>
            {mItem.title}
          </MenuItem>
        ))}
      </Menu>
    </React.Fragment>
  );
};

export default OfficeGridActions;
